import { DismissibleTag } from '@carbon/react';
import classNames from 'classnames';
import styles from './filter-chip.module.scss';

interface FilterChipProps {
  children: React.ReactNode;
  onClose: () => void;
  disabled?: boolean;
  removeLabel?: string;
}

export const FilterChip = ({
  children,
  onClose,
  disabled,
  removeLabel = 'Remove filter',
}: FilterChipProps) => (
  <DismissibleTag
    type="gray"
    size="sm"
    text={children as string}
    onClose={onClose}
    title={removeLabel}
    dismissTooltipLabel={removeLabel}
    className={classNames({ [styles.chipDisabled]: disabled })}
  />
);
